import { Emitter } from 'mitt'
import { Events } from './mitt'
import {
  isDialogEventHandlerArgError,
  isDialogEventHandlerArgSuccess,
} from './dialog_guard'
import { either } from 'fp-ts'
import { pipe } from 'fp-ts/lib/function'
import { Either } from 'fp-ts/lib/Either'
import * as E from 'fp-ts/Either'

import {
  DialogEventHandlerArgError,
  DialogEventHandlerArgSuccess,
} from '../types/dialog'

export const emitOfficeDialiogEvent = (
  emitter: Readonly<Emitter<Events>>,
  arg: Readonly<
    | {
        message: string
        origin: string | undefined
      }
    | {
        error: number
      }
  >
) => pipe(arg, toEitherDialogEventHandlerArg, emitDialogEvent(emitter))

export const toEitherDialogEventHandlerArg = (
  arg: unknown
): Either<DialogEventHandlerArgError, DialogEventHandlerArgSuccess> =>
  pipe(arg, (a) =>
    isDialogEventHandlerArgSuccess(a)
      ? either.right(a)
      : isDialogEventHandlerArgError(a)
      ? either.left(a)
      : either.left({ error: 1 } as DialogEventHandlerArgError)
  )

export const emitDialogEvent =
  (emitter: Readonly<Emitter<Events>>) =>
  (arg: Either<DialogEventHandlerArgError, DialogEventHandlerArgSuccess>) => {
    emitter.emit('OfficeDialiogEvent', arg)
  }

export const matchDialogEvent =
  <T>(
    handleLeft: (arg: DialogEventHandlerArgError) => T,
    handleRight: (arg: DialogEventHandlerArgSuccess) => T
  ) =>
  (arg: Either<DialogEventHandlerArgError, DialogEventHandlerArgSuccess>) => {
    return pipe(arg, E.match(handleLeft, handleRight))
  }
